<script setup lang="ts">
import { defineProps } from "vue";

defineProps<{
  color: string;
}>();
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 1020.000000 1020.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,1020.000000) scale(0.100000,-0.100000)"
      stroke="none"
    >
      <path
        :fill="color"
        d="M4991 9891 c-67 -132 -121 -243 -121 -246 0 -3 50 -5 110 -5 l110 0
0 -2260 0 -2260 -1255 0 c-1248 0 -1255 0 -1255 -20 0 -20 7 -20 2535 -20
2528 0 2535 0 2535 20 0 20 -7 20 -1260 20 l-1260 0 0 2260 0 2260 115 0 115
0 -121 243 c-66 133 -122 244 -124 246 -2 2 -58 -105 -124 -238z"
      />
    </g>
  </svg>
</template>
